import React from "react";
import { adminAccess, supplierAccess, userAccess } from "./useRoleAccess";

export const CultivationRoutes = [

];
